import styles from './_index.module.css';

const disclaimers = [
  'Opportunities to upgrade to the Hands-On Trailer Backup Experience or The Ultimate Towing Training Experience will be available on-site for the full price rate.',
  'Additional costs applied for guests of the primary driver.',
  'Towing capability varies based on cargo, vehicle configuration, accessories, and number and weight of passengers. Max tow often requires optional equipment at an extra charge.',
  "Driver-assist features are supplemental and do not replace the driver's attention, judgment, and need to control the vehicle. They do not make your vehicle autonomous or replace your responsibility to drive safely. Please only use if you will pay attention to the road and be prepared to take over at any time. See Owner's Manual for details and limitations.",
];

const superscripts = ['1', '2', '3', '4'];

interface DisclaimersProps {
  theme?: 'light' | 'dark';
  include?: number[];
}

export function Disclaimers({ theme = 'light', include }: DisclaimersProps) {
  const filteredDisclaimers = include
    ? disclaimers.filter((_, index) => include.includes(index + 1))
    : disclaimers;

  const getIndex = (disclaimer: string) => disclaimers.indexOf(disclaimer);

  return (
    <div className={`${styles.wrapper} ${theme === 'dark' ? styles.dark : styles.light}`}>
      <div className={styles.contentSection}>
        <div className={styles.disclaimerList}>
          {filteredDisclaimers.map((disclaimer, i) => {
            const originalIndex = getIndex(disclaimer);
            return (
              <p key={originalIndex} className={styles.disclaimer}>
                <span className={styles.superscript}>{superscripts[originalIndex]}</span>
                {disclaimer}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}
